module.exports = __webpack_public_path__ + "img/up.a6aa6c70.svg";